import React, { useContext, useEffect, useReducer, useMemo } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import Table, { TableHook } from '../Table';
import { lockedReducer } from '../Utils/reducers';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditRotasRegioes from './editRotasRegioes';


const tipo = {
    1: "Rota",
    2: "Região"
}

const getcolumns = (setState) => {
    const columns = []

    columns.push({ field: 'nome_rota_regiao', headerName: 'Nome', width: 170, })
    columns.push({
        field: 'id_tipo', headerName: 'Tipo', width: 100,
        renderCell: ({ value }) => <Box>{tipo[value]}</Box>
    })
    columns.push({ field: 'estado', headerName: 'Estado', flex: 1 })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar tabela'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Deleta tabela'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })


    return columns
}

const getRotasRegioes = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/frete/`)
    if (res.status === 200) {
        setState({ rows: res.data })
    }
    setLoader(false)
}

const deleteRotaRegiao = async (setLoader, setState, getTables, id) => {
    setLoader(true)
    const res = await api.post(`/frete/deleta/${id}`)
    if (res.status === 200) {
        await getTables(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const RotasRegioes = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        deleteRow: null
    })

    const { setLoader } = useContext(externalComponent)

    const [table] = TableHook()

    const reloadData = () => {
        getRotasRegioes(setLoader, setState)
    }

    useEffect(() => {
        getRotasRegioes(setLoader, setState)
    }, [])

    return (
        <>

            {
                state.editRow &&
                <EditRotasRegioes
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                    setLoader={setLoader}
                />
            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a Rota/Região ${state.deleteRow.nome_rota_regiao} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteRotaRegiao(setLoader, setState, getRotasRegioes, state.deleteRow.id)}
                />

            }

            <Box sx={{ flex: 1 }}>
                <Table
                    paginationMode='client'
                    className='contabil-grid'
                    rows={state.rows}
                    columns={useMemo(() => getcolumns(setState), [state.rows, state.edit])}
                    pagination={false}
                    toolbar
                    slots={{
                        addComponent: () => setState({ editRow: {} }),
                        columnComponent: true
                    }}
                    rowHeight={30}
                    innerRef={table}
                />
            </Box>

        </>
    )
}

export default RotasRegioes;
